import { NgModule } from '@angular/core';
import { UserUiModule } from '@sdvor/user/ui';
import { provideConfig } from '@spartacus/core';
import { userI18nConfig } from '@user/const';
import { UserDataAccessModule } from '@user/data-access';
import { UserFeatureModule } from '@user/feature';

@NgModule({
  providers: [provideConfig(userI18nConfig)],
  imports: [UserDataAccessModule, UserFeatureModule, UserUiModule],
})
export class SdvorUserShellModule {}
